import { DiContainer } from '@jkhy/frontend-utils/di';
import { observe } from '@jkhy/frontend-utils/lit/directives';
import { DynamicComponentExitReason } from '@jkhy/frontend-utils/lit/dynamic-component-registry';
import { Observable, countdown } from '@jkhy/frontend-utils/observable';
import { OpenTimeAccessDialogFn } from '@treasury/domain/services/logout';
import { TmDialogService } from '@treasury/presentation/services/dialog';
import { noOp } from '@treasury/utils';
import { html } from 'lit';
import type { OmegaDialogService } from '../../services/omega-dialog';

const title = 'Access Timeout';
const confirmButtonLabel = 'OK';

function createPromptTemplate(countdown$: Observable<number>) {
    return html`<p>
        Your allowed time access will expire in ${observe(countdown$)} seconds and you will be
        logged out. Click ${confirmButtonLabel} if you wish to continue working for the remaining
        time.
    </p>`;
}

export const openTimeAccessDialog: OpenTimeAccessDialogFn = async function openTimeAccessDialog(
    config
) {
    const { warningSeconds, logoSource } = config;
    const countdown$ = countdown(warningSeconds);
    const template = createPromptTemplate(countdown$);
    const di = await DiContainer.getInstance();
    const dialogService = di.get(TmDialogService) as OmegaDialogService;

    const result = dialogService.open(
        template,
        title,
        {
            buttons: [
                {
                    reason: DynamicComponentExitReason.Confirm,
                    label: confirmButtonLabel,
                },
            ],
        },
        {
            logoSource,
        }
    );

    return {
        closed: result.then(noOp),
        close: () => dialogService.close(),
    };
};
